import React from "react";
import { Link } from "react-router-dom";
import { Badge } from "reactstrap";
import classNames from "classnames";
import { MdFileDownload, MdDelete } from "react-icons/md";
import Button from "../Form/Button";
import Img from "../Img";
import Player from "../Player"

const AdRow = ({ data, ...props }) => {
  const handleDelete = () => {
    const confirmDelete = window.confirm(`تبلیغ ${data.name} برای همیشه حذف خواهد شد.`);
    if (confirmDelete) {
      props.onDelete();
    }
  }
  return (
    <div
      className={classNames(
        'd-flex flex-row p-2 align-items-center',
        {
          disabled: props.disabled
        }
      )}
    >
      <Link
        to={`/ads/${data.id}`}
        href={`/ad/${data.id}`}
        className="d-flex flex-row align-item-center overlay-link"
      />
      <Img
        src={data.cover ? `${data.cover}/r/100x133` : data.cover}
        width={60}
        height={80}
        text=" "
        fill="#e1e1e1"
        className="rounded"
      />
      <div className="d-flex flex-column justify-content-center align-items-start mr-3">
        <h6 className="m-0">{data.name}</h6>
        <h6 className="m-0">
          <small>{data.id}</small>
        </h6>
        <div>
          <Badge>{data.quality}</Badge>
          <Badge
            className="mr-1"
            color={data.active ? 'success' : 'dark'}
          >
            {data.active ? 'فعال' : 'غیر فعال'}
          </Badge>
        </div>
      </div>

      <div className="d-flex align-items-center mr-auto ml-3">
        <Player src={data.oggPath} />
        <a
          href={data.oggPath}
          className={classNames('btn btn-link has-icon')}
          title="دانلود فایل صوتی"
          target="_blank"
          rel="noopener noreferrer"
        >
          <MdFileDownload />
        </a>
        {props.onDelete &&
          <Button
            type="button"
            color="link"
            className={classNames('text-danger has-icon')}
            title="حذف تبلیغ"
            onClick={handleDelete}
          >
            <MdDelete />
          </Button>
        }
      </div>
    </div>
  )
}

export default AdRow;